<div class="basePage">
  <h1 class="mat-h1" color="primary-font-color">
    Search
  </h1>
  <div style="float:left; margin-left: 20px">
    <p style="font-size: smaller; margin-bottom: 2px; margin-left: 20px">Person Search</p>
    <p style="margin-top: 2px">
      <input [(ngModel)]="searchTermPerson"  (keyup)="handleKeyUp($event)" placeholder="Person Search"
        style="height:1.5em; border-radius: 10px; margin-left: 20px; width: 20em; padding-left: 10px">
    </p>
  </div>
  <div style="float:left; margin-left: 20px">
    <p style="font-size: smaller; margin-top: 35px">and/or</p>
  </div>
  <div style="float:left">
    <p style="font-size: smaller; margin-bottom: 2px; margin-left: 20px">Unit Search</p>
    <p  style="margin-top: 2px">
      <input [(ngModel)]="searchTermUnit"  (keyup)="handleKeyUp($event)" placeholder="Unit Search"
        style="height:1.5em; border-radius: 10px; margin-left: 20px; width: 20em; padding-left: 10px">
    </p>
  </div>
  <div style="float:left; margin-left: 20px; padding-top: 20px;">
    @if (!searching) {
      <button mat-raised-button color="primary" style="margin-left: 20px" (click)="navigateResult()">Search</button>
    }
    @if (searching) {
      <button mat-raised-button color="primary" style="margin-left: 20px" disabled>Searching</button>
    }
  </div>
  @if (config.mode === 'list') {
    <app-table [config]="config" [drilldown]="true"></app-table>
  }
  <p  class="mat-h2" style="font-weight: lighter;">Tips:</p>
  <ul class="mat-body"  style="font-weight: lighter;">
    <li class="header"> Search Scope</li>
    <ul>
        <li>Search words in person field are matched against person first name, last name, title, phone email, notes and personal address (if not resident at the unit)</li>
        <li>Search words in the unit field are matched against the unit name, address, postcode, notes and car spaces</li>
        <li>If you enter both unit and person search words, the search will only show records that match both the person and the unit search criteria</li>    
        <li>Contacts that are not linked to a unit will not be returned</li>
    </ul>
  
    <li class="header">Wildcard Searches - To search part of a word, use * to match any characters</li>
    <ul>
        <li>By default search matches WHOLE WORD only - so searching 'word' does not match 'words'</li>
        <li>Use <span class='search'>Wor*</span> to match any word starting with "wor"</li>
        <li>Use <span class='search'>*rds</span> to match any word ending with "rds"</li>
        <li><span class='search'>*ord*</span> to match any word containing "ord"</li>
    </ul>

    <li class="header">Searches match any of the words, use + if word is required</li>
    <ul>
        <li>Searching <span class='search'>john jones</span> will return results containing either John or Jones</li>
        <li>Search <span class='search'>+John +Jones</span> if you want results that contain both words John and Jones</li>
    </ul>
    
    <li class="header">Email Address Search</li>
    <ul>
        <li>To search for an email address, each punctuation is considered a new word jenny52&#64;yahoo.com is 3 words, jenny52 yahoo and com are separate words that can be searched individually</li>
        <li>Search for jenny52&#64;yahoo.com gives an error</li>
        <li>You need to search <span class='search'>+jenny52 +yahoo</span> or simply <span class='search'>jenny52</span></li>
    </ul>
    <li class="header">Phone Number Search</li>
    <ul>
        <li>To seach for a phone number, you are looking for an exact match, <span class='search'>0871234567</span> does not match if the phone number was entered with spaces in there, in which case 087 and 1234567 are considered separate words</li>
        <li>Likely the best way to search for 0871234567 is to search <span class='search'>*1234567</span> so that it matches anything ending with that, so matches if data was entered with or without the spaces</li>
    </ul>
  <span class='search'></span>
</ul>
</div>
